module.exports = __webpack_public_path__ + "img/platform.4ff5bc5e.png";